module.exports = __webpack_public_path__ + "img/block-g-1.99aa63dc.jpg";